<template>
  <div class="fullscreen items-center justify-center column spinner_overlay">
    <q-spinner
      size="100px"
      class="q-mb-xl"
      color="primary"
    />
    <p class="q-mb-sm text-weight-bolder">
      {{ $t('login.loadingPage') }}
    </p>
    <q-btn
      size="xs"
      class="text-weight-bolder btn_link"
      flat
      @click="logoutAndRedirect"
    >
      {{ $t('login.gotoLoginPageBtn') }}
    </q-btn>
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import Auth from 'src/mixins/Auth';
import { auth } from 'src/store/auth';

export default {
  name: 'RefreshPageSpinner',

  mixins: [Auth],

  methods: {
    ...mapActions(auth, ['changeLoaderState']),

    async logoutAndRedirect() {
      await this.signOut(true);
      this.changeLoaderState(false);
    }, // logoutAndRedirect()
  },
};
</script>

<style lang="scss" scoped>
  .spinner_overlay {
    &::before{
      content: '';
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgb(255, 255, 255);
      z-index: -1;
    }
  }
</style>
